import { render, staticRenderFns } from "./LoginPageLoader.vue?vue&type=template&id=7f00faf2&scoped=true&"
import script from "./LoginPageLoader.vue?vue&type=script&lang=ts&"
export * from "./LoginPageLoader.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPageLoader.vue?vue&type=style&index=0&id=7f00faf2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f00faf2",
  null
  
)

export default component.exports